import { render, staticRenderFns } from "./parts-add.vue?vue&type=template&id=8adff2ca&scoped=true&"
import script from "./js/parts-add.js?vue&type=script&lang=js&"
export * from "./js/parts-add.js?vue&type=script&lang=js&"
import style0 from "./parts-add.vue?vue&type=style&index=0&id=8adff2ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adff2ca",
  null
  
)

export default component.exports